import React from 'react';
import nanoid from 'nanoid';
import Shape from 'ati-ui-react/components/Shape';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';
import Badge from 'ati-ui-react/components/Badge';

import { CheckCardContainer, Description, Image, Amount, AmountContainer } from './CheckCardStyles';

import idx from './img/idx.svg';
import reputation from './img/reputation.svg';
import ts from './img/ts.svg';

const serviceType = {
  Idx: {
    icon: idx,
    tooltip: 'IDX — проверка достоверности данных',
  },
  Reputation: {
    icon: reputation,
    tooltip: 'Репутация — проверка контрагентов, водителей и\u00A0ТС',
  },
  Avtocod: {
    icon: ts,
    tooltip: 'Автокод — проверка ТС и\u00A0водителей',
  },
};

function CheckCard({ image, description, limitBalance, amount, promoAmount, onClick }) {
  const uniqueId = nanoid();
  return (
    <CheckCardContainer onClick={onClick}>
      <Shape color="white" shadow className="check-card">
        <Image
          data-tip
          data-for={uniqueId}
          src={serviceType[image]?.icon}
          alt={serviceType[image]?.icon}
        />
        <ReactTooltip id={uniqueId} effect="solid">
          {serviceType[image].tooltip}
        </ReactTooltip>
        <Description>
          {description} {!!promoAmount && !limitBalance && <Badge color="orange">Скидка</Badge>}
        </Description>

        <Amount>
          {limitBalance ? (
            <div>
              <div className="balance">{limitBalance} бесплатно</div>
              затем по {Math.floor(amount)} ат.
            </div>
          ) : (
            <AmountContainer>
              {!!promoAmount && (
                <span
                  style={{
                    textDecoration: promoAmount ? 'line-through' : '',
                    color: promoAmount ? 'black' : '',
                  }}
                >
                  {Math.floor(amount)} ат.
                </span>
              )}

              <span
                style={{
                  fontWeight: promoAmount ? 'bold' : '',
                  color: promoAmount ? 'black' : '',
                }}
              >
                {Math.floor(promoAmount || amount)} ат.
              </span>
            </AmountContainer>
          )}
        </Amount>
      </Shape>
    </CheckCardContainer>
  );
}

export default CheckCard;
